import { Toaster as Sonner } from "sonner";

/** App-wide toast surface, themed against the v0.5 tokens. */
export function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      toastOptions={{
        style: {
          background: "var(--surface)",
          color: "var(--fg)",
          border: "1px solid var(--border)",
          borderRadius: "var(--radius-md, 6px)",
          fontSize: "12.5px",
        },
      }}
    />
  );
}
